import { render } from "./Uploader.vue?vue&type=template&id=e39d0760&ts=true"
import script from "./Uploader.vue?vue&type=script&lang=ts"
export * from "./Uploader.vue?vue&type=script&lang=ts"

import "./Uploader.vue?vue&type=style&index=0&id=e39d0760&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__